import * as Yup from "yup";
import { countryCodes } from "./phoneNumber.constants";

export const settingValidationSchema = Yup.object({
  name: Yup.string().trim().required("Name is required"),
  email: Yup.string()
    .trim()
    .email("Enter a valid email")
    .required("Email is required"),
  countryCode: Yup.string()
    .matches(/^\+[1-9][0-9]{0,3}$/i, "Select a valid country code")
    .required("Country code is required"),
  phoneNumber: Yup.string()
    .trim()
    .matches(/^[0-9]{6,14}$/i, "Enter digits only (6-14)")
    .required("Phone number is required"),
  voiceConfiguration: Yup.string().nullable(),
  chatConfiguration: Yup.string().nullable(),
});

export const CONSUMER_FORM_INITIAL_VALUES = {
  name: "",
  email: "",
  countryCode: countryCodes[0].value,
  phoneNumber: "",
  voiceConfiguration: "",
  chatConfiguration: "",
};

export const CREATE_CONSUMER_INITIAL_VALUES = {
  name: "",
  email: "",
  password: "",
};

export const createSettingValidationSchema = Yup.object({
  name: Yup.string()
    .min(2, "Name must be at least 2 characters")
    .required("Name is required"),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
});